import { useEffect, useState } from 'react'
import MineralService from '../services/MineralService'

export default function useMinerals() {
  const [minerals, setMinerals] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  async function fetchMinerals() {
    try {
      setIsLoading(true)
      const { data } = await MineralService.getMinerals()
      setMinerals(data.minerals)
    } catch (error) {
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchMinerals()
  }, [])

  return { minerals, isLoading }
}
